import React from 'react';
import classNameBind from 'classnames/bind';
import { withTranslation } from '../Translator';
import Caption from '../Caption';
import Label from '../Label';
import Stack from '../Stack';
import styles from './FolderPickerButton.module.css';

const bindClasses = classNameBind.bind(styles);

const FolderPickerButton = ({ onClick, mainSection = '', folders, t }) => (
  <>
    <Label type="small" required>{t('FolderPickerButton.location')}</Label>
    <div onClick={onClick} className={bindClasses('button')} role="button" tabIndex="0" data-ppuc-id="FolderPickerButton">
      <Stack wrap spacing="narrow">
        {mainSection && (
          <>
            <Stack.Item><Caption subdued>{mainSection}</Caption></Stack.Item>
            <Stack.Item><Caption subdued>/</Caption></Stack.Item>
          </>
        )}
        <Stack.Item><Caption>{t('FolderPickerButton.main-folder')}</Caption></Stack.Item>
        {folders.map(el => (
          <React.Fragment key={el.id}>
            <Stack.Item><Caption subdued>/</Caption></Stack.Item>
            <Stack.Item><Caption key={el.id}>{el.name}</Caption></Stack.Item>
          </React.Fragment>
        ))}
      </Stack>
    </div>
  </>
);

const enhanced = withTranslation('components')(FolderPickerButton);
enhanced.displayName = 'FolderPickerButton';

export default enhanced;
export { FolderPickerButton };
